import { render, staticRenderFns } from "./OrderCreateDialog.vue?vue&type=template&id=6e5ef2e0&"
import script from "./OrderCreateDialog.vue?vue&type=script&lang=js&"
export * from "./OrderCreateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports